export const avgCostPerKWByState: Record<string, number> = {
  Alabama: 2.45,
  Alaska: 2.94,
  Arizona: 2.33,
  Arkansas: 2.51,
  California: 2.91,
  Colorado: 2.79,
  Connecticut: 2.87,
  Delaware: 2.71,
  Florida: 2.59,
  Georgia: 2.47,
  Hawaii: 2.74,
  Idaho: 2.42,
  Illinois: 2.69,
  Indiana: 2.61,
  Iowa: 2.65,
  Kansas: 2.5,
  Kentucky: 2.53,
  Louisiana: 2.58,
  Maine: 2.66,
  Maryland: 2.81,
  Massachusetts: 2.95,
  Michigan: 2.72,
  Minnesota: 2.78,
  Mississippi: 2.49,
  Missouri: 2.68,
  Montana: 2.64,
  Nebraska: 2.52,
  Nevada: 2.39,
  "New Hampshire": 2.91,
  "New Jersey": 2.89,
  "New Mexico": 2.37,
  "New York": 2.9,
  "North Carolina": 2.55,
  "North Dakota": 2.6,
  Ohio: 2.63,
  Oklahoma: 2.54,
  Oregon: 2.73,
  Pennsylvania: 2.7,
  "Rhode Island": 2.92,
  "South Carolina": 2.57,
  "South Dakota": 2.62,
  Tennessee: 2.56,
  Texas: 2.48,
  Utah: 2.29,
  Vermont: 2.93,
  Virginia: 2.6,
  Washington: 2.75,
  "West Virginia": 2.59,
  Wisconsin: 2.67,
  Wyoming: 2.5,
};

export const solarProductionFactor: Record<string, number> = {
  Alabama: 1450,
  Alaska: 1100,
  Arizona: 1700,
  Arkansas: 1500,
  California: 1650,
  Colorado: 1600,
  Connecticut: 1350,
  Delaware: 1400,
  Florida: 1600,
  Georgia: 1550,
  Hawaii: 1700,
  Idaho: 1450,
  Illinois: 1350,
  Indiana: 1350,
  Iowa: 1400,
  Kansas: 1450,
  Kentucky: 1400,
  Louisiana: 1500,
  Maine: 1300,
  Maryland: 1400,
  Massachusetts: 1300,
  Michigan: 1250,
  Minnesota: 1350,
  Mississippi: 1450,
  Missouri: 1350,
  Montana: 1400,
  Nebraska: 1450,
  Nevada: 1650,
  "New Hampshire": 1300,
  "New Jersey": 1350,
  "New Mexico": 1700,
  "New York": 1300,
  "North Carolina": 1450,
  "North Dakota": 1350,
  Ohio: 1350,
  Oklahoma: 1500,
  Oregon: 1400,
  Pennsylvania: 1300,
  "Rhode Island": 1300,
  "South Carolina": 1500,
  "South Dakota": 1350,
  Tennessee: 1450,
  Texas: 1600,
  Utah: 1650,
  Vermont: 1250,
  Virginia: 1400,
  Washington: 1350,
  "West Virginia": 1350,
  Wisconsin: 1300,
  Wyoming: 1500,
}; 